import { Button, Grid2, MenuItem, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useWatch } from "react-hook-form";
import { toolsValidationSchema } from "../../../validation/schemas/toolsSchema";
import { TextFieldStyles } from "../../../styles/commonStyles";
import CustomAlert from "../../alert/alert.component";

const UpdateSensorForm = ({
  onFormDataChange,
  control,
  errors,
  sensorTypes,
  frequencyUpdateRanges,
  fields,
}) => {
  const watchedValues = useWatch({ control });
  const [fieldValue, setFieldValue] = useState(control._defaultValues.field_id);
  const [activeAlert, setActiveAlert] = useState(false);

  useEffect(() => {
    if (onFormDataChange && watchedValues) {
      onFormDataChange(watchedValues);
    }
  }, [watchedValues, onFormDataChange]);

  useEffect(() => {
    if (control._defaultValues.field_id !== fieldValue) {
      setActiveAlert(true);
    } else {
      setActiveAlert(false);
    }
  }, [fieldValue, control._defaultValues.field_id]);

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            name="nickname"
            control={control}
            rules={toolsValidationSchema.gatewayName}
            render={({ field }) => (
              <TextField
                {...field}
                variant="filled"
                label="Sensore"
                sx={{ ...TextFieldStyles }}
                fullWidth
                error={!!errors.nickname}
                helperText={errors.nickname?.message}
              />
            )}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            name="update_frequency"
            control={control}
            rules={toolsValidationSchema.frequencyUpdate}
            render={({ field }) => (
              <TextField
                {...field}
                variant="filled"
                label="Frequenza aggiornamento"
                select
                sx={{ ...TextFieldStyles }}
                fullWidth
                error={!!errors.update_frequency}
                helperText={errors.update_frequency?.message}
              >
                {frequencyUpdateRanges && frequencyUpdateRanges.length > 0 ? (
                  frequencyUpdateRanges.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {`${option.minute} minuti`}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value={""}>Nessuna tipologia disponibile</MenuItem>
                )}
              </TextField>
            )}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            name="field_id"
            control={control}
            render={({ field }) => (
              <>
                <TextField
                  {...field}
                  variant="filled"
                  label="Terreno"
                  select
                  sx={{ ...TextFieldStyles }}
                  fullWidth
                  error={!!errors.field}
                  helperText={errors.field?.message}
                  onChange={(e) => {
                    setFieldValue(e.target.value);
                    field.onChange(e);
                  }}
                >
                  {fields && fields.length > 0 ? (
                    fields.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value={""}>Nessun terreno disponibile</MenuItem>
                  )}
                </TextField>
                {activeAlert && (
                  <CustomAlert
                    severity="warning"
                    style={{ mt: 1 }}
                    action={
                      <Button
                        color="inherit"
                        size="small"
                        onClick={() => setActiveAlert(false)}
                      >
                        Ok
                      </Button>
                    }
                    message={
                      "Attenzione! Dovrai riposizionare il sensore nel nuovo terreno"
                    }
                  />
                )}
              </>
            )}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            name="sensor_type"
            control={control}
            rules={toolsValidationSchema.sensorType}
            render={({ field }) => (
              <TextField
                {...field}
                variant="filled"
                label="Tipologia"
                select
                sx={{ ...TextFieldStyles }}
                fullWidth
                error={!!errors.sensor_type}
                helperText={errors.sensor_type?.message}
                disabled
              >
                {sensorTypes && sensorTypes.length > 0 ? (
                  sensorTypes.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value={""}>Nessuna tipologia disponibile</MenuItem>
                )}
              </TextField>
            )}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            name="devEUI"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                variant="filled"
                label="Dev EUI"
                sx={{ ...TextFieldStyles }}
                fullWidth
                disabled
              />
            )}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            name="appEUI"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                variant="filled"
                label="App EUI"
                sx={{ ...TextFieldStyles }}
                fullWidth
                disabled
              />
            )}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            name="appKey"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                variant="filled"
                label="App Key"
                sx={{ ...TextFieldStyles }}
                fullWidth
                disabled
              />
            )}
          />
        </Grid2>
      </Grid2>
    </>
  );
};

export default UpdateSensorForm;
